import { useQuery } from '@tanstack/react-query'
import { useUnitsString } from './useUnitsString'
import { unitQueries } from '../api/units'
import { IUnitModel } from '../interfaces/models/units.interfaces'

const userUnits = (
  societyId: string | undefined,
  units: IUnitModel[]
): IUnitModel[] => {
  const filteredUnits = units.filter((unit) => !unit.isUnassigned)
  if (societyId) {
    return filteredUnits.filter((unit) => unit.societyId === societyId)
  }
  return filteredUnits
}

export const useUserUnitsString = (
  userId: string | undefined,
  societyId: string | undefined
): string => {
  const { data } = useQuery(unitQueries.getUserUnits(userId))
  const units = userUnits(societyId, data || [])
  const unitsString = useUnitsString(units || [], false)

  return unitsString
}
